// useInfiniteScroll.js
import { useEffect, useRef } from "react";

export function useInfiniteScroll({
  onLoadMore,
  loading,
  hasMore,
  threshold = 20,
}) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !loading && hasMore) {
          onLoadMore();
        }
      },
      { rootMargin: `${threshold}px` },
    );

    if (sentinelRef.current) observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, [onLoadMore, loading, hasMore, threshold]);

  return sentinelRef;
}
